/**
 * ops (opetan) 依頼ドメインの共有型。frontend (product-innovation-lab)・product-api・
 * customer-success MCP が同じ列挙・contract を参照するための単一定義。
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business ops 依頼の共有型（サービス / ステート / 緊急度 / カテゴリ / 分類 / SLA 状態 / 起票経路）を全 consumer に提供する。システムオペレーション（アラート由来の自動起票）の種別は OPS_SYSTEM_CATEGORIES が単一 source。起票経路は既定値（OPS_REQUEST_SOURCE_DEFAULT）と経路別メタのキー（OPS_SOURCE_METADATA_CIO_CHAT_URL）も単一 source として持つ
 * @graph-connects none
 */
/** 依頼の進捗ステートの値（API の zod enum・BQ 生値の検証が参照する単一 source）。 @graph-connects none */
export const OPS_STATES = ['open', 'investigating', 'blocked', 'closed'];
/**
 * ステート → 日本語ラベル。活動ログ本文（`ステータス: 調査中 → 完了`）のように **保存される文言**で
 * 使うため、UI の i18n ではなくここを単一 source にする（i18n の ja 訳と同じ語彙にそろえること）。
 * @graph-connects none
 */
export const OPS_STATE_LABELS = {
    open: '未対応',
    investigating: '調査中',
    blocked: '保留',
    closed: '完了',
};
/**
 * システムオペレーション（#fatal / #daily_toils などのアラートから自動で起票される依頼）の種別。
 * 依頼者のいる通常の依頼とは別の一覧で扱い、キューの件数・SLO・KPI に混ぜない
 * （docs/operations/system-ops-intake.md §1）。「どの種別がシステム運用か」はこのタプルと
 * `isOpsSystemCategory` だけが知り、除外する側は種別名を書かずに必ずそれを経由する。
 * @graph-connects none
 */
export const OPS_SYSTEM_CATEGORIES = ['システムオペレーション'];
/**
 * 一覧・ステート件数の対象範囲。`requests` = 依頼者のいる依頼（Queue。システムオペレーションを除く）、
 * `system` = システムオペレーションだけ（システム運用タブ）、`all` = 両方（My Requests。本人が起票・担当した
 * 依頼を種別で隠さない）。product-api の query・PIL・MCP が同じ値を使う。
 * @graph-connects none
 */
export const OPS_LIST_SCOPES = ['requests', 'system', 'all'];
/** 対象範囲の既定値。既存の呼び出し元（Queue・My Requests・MCP）は何も渡さずに依頼者のいる依頼だけを見る。 @graph-connects none */
export const OPS_LIST_SCOPE_DEFAULT = 'requests';
/** 起票経路の既定値（経路を持たない旧ドキュメント / PIL フォーム起票）。 @graph-connects none */
export const OPS_REQUEST_SOURCE_DEFAULT = 'pil';
/**
 * `sourceMetadata` の Channel.io chat URL キー（design §2.2 の `source_metadata.cio_chat_url`）。
 * 書き手（product-api の起票）と読み手（`nativeOpsDocToRequestRow` 経由の customer-success MCP）が
 * 同じ綴りを参照するための単一 source。
 * @graph-connects none
 */
export const OPS_SOURCE_METADATA_CIO_CHAT_URL = 'cio_chat_url';
//# sourceMappingURL=types.js.map